import { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Watermark } from "@/components/brand/Watermark";
import { SiteHeader } from "@/components/layout/SiteHeader";
import { BRAND, useI18n } from "@/i18n/I18nContext";
import { HealBoundary } from "@/components/selfheal/HealBoundary";
import { FaultProbe } from "@/components/selfheal/FaultProbe";
import { applyPendingUpdate } from "@/lib/selfheal";
import { CustomPlanCta } from "@/components/apps/PlanNotes";
import { NewsSoftPrompt } from "@/components/pwa/NewsPush";
import { InAppBrowserBanner } from "@/components/layout/InAppBrowserBanner";

const FooterInstallLink = () => {
  const { t } = useI18n();
  return <Link to="/installer-un-apk" className="text-[var(--gold)] underline-offset-4 hover:underline" data-testid="footer-install-link">{t("nav.install")}</Link>;
};

const FooterAdminLink = () => {
  const { t } = useI18n();
  return <Link to="/admin" className="text-neutral-500 underline-offset-4 hover:text-neutral-300 hover:underline" data-testid="footer-admin-link">{t("nav.administration")}</Link>;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    applyPendingUpdate();
  }, [pathname]);
  return null;
};

const PageBoundary = () => {
  const { pathname } = useLocation();
  return (
    <HealBoundary name="page" resetKey={pathname}>
      <FaultProbe />
      <Outlet />
    </HealBoundary>
  );
};

export const SiteLayout = () => (
  <div className="App">
    <ScrollToTop />
    <InAppBrowserBanner />
    <NewsSoftPrompt />
    <Watermark />
    <div className="relative z-10 flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <PageBoundary />
      </main>
      <div className="mx-auto mt-16 max-w-7xl px-4 empty:hidden sm:px-8"><CustomPlanCta footer testId="footer-custom-plan" /></div>
      <footer className="mt-10 border-t border-[rgba(245,197,66,0.18)] bg-[rgba(10,8,9,0.9)]" data-testid="site-footer">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-8 text-xs text-neutral-400 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <span className="font-display tracking-widest">© {new Date().getFullYear()} {BRAND}</span>
          <span className="flex flex-wrap items-center gap-4">
            <FooterInstallLink />
            <FooterAdminLink />
          </span>
          <span className="font-sign text-lg gold-text">by Fabrice</span>
        </div>
      </footer>
    </div>
  </div>
);
